export default {
  DEATH: "death",
  INJURY: "injury",
  SICKNESS: "sickness"
}
